const SEARCH_URLS = {
  swdc: "https://www.solarwinds.com/internalsearch/search",
  support: "https://support.solarwinds.com/internalsearch/search",
} as const;

export const getSearchUrl = (site?: string) => {
  return site === "support" ? SEARCH_URLS.support : SEARCH_URLS.swdc;
};

const getCurrentSite = () => {
  return document.documentElement.getAttribute("data-site") ?? "swdc";
};

export const onSearchSubmit = (searchValue: string) => {
  const trimmedSearchValue = searchValue.trim();
  if (trimmedSearchValue === "") {
    return;
  }

  const url = new URL(getSearchUrl(getCurrentSite()));
  url.searchParams.set("q", trimmedSearchValue);
  window.location.href = url.href;
};
